<template>
    <div class="news">
        <div class="top">
            <img src="../image/logo.png" alt="" class="loGo">
            <el-row class="tac">
                <el-col :span="12">
                    <el-menu default-active="2" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff"
                        active-text-color="#ffd04b" :unique-opened="true">
                        <el-submenu index="1">
                            <template slot="title">
                                <img src="../image/menu.png" alt="" class="logo-1">
                            </template>
                            <el-menu-item-group>
                                <template v-for="(menu, index) in navList">
                                    <el-menu-item :index="`1-${index + 1}`" v-if="menu.children.length == 0"
                                        :key="menu.index">
                                        <router-link :to="menu.route" class="linkclass">
                                            {{ menu.name }}
                                        </router-link>
                                    </el-menu-item>
                                    <el-submenu :index="`1-${index + 1}`" v-if="menu.children.length !== 0"
                                        :key="menu.index">
                                        <template slot="title">{{ menu.name }}</template>
                                        <el-menu-item v-for="(subMenu, subIndex) in menu.children"
                                            :index="`1-${index + 1}-${subIndex + 1}`" :key="subMenu.index">
                                            <router-link :to="subMenu.route" class="linkclass">{{ subMenu.name
                                            }}</router-link>
                                        </el-menu-item>
                                    </el-submenu>
                                </template>
                            </el-menu-item-group>

                        </el-submenu>
                    </el-menu>
                </el-col>
            </el-row>
            <div class="introduce">
                <p class="p1">智如客科技-新闻资讯-公司动态</p>
                <p class="p1none" style="display: none;">新闻资讯</p>
                <p class="p2">Zhiruke Technology - News and Information - Company news</p>
                <p class="p2none" style="display: none;">News and information</p>
            </div>
        </div>
        <div class="tabs">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="新闻资讯" name="first">
                    <div class="first-framework">
                        <div class="first-1">
                            <div class="first-1-1" @click="handleToDetail(leftItemFirst.id)">
                                <!-- <img :src="baseURL + leftItemFirst.cover" alt=""> -->
                                <img class="first-1-1-img" :src="baseURL + leftItemFirst.cover">
                                <p>{{ leftItemFirst.title }}</p>
                            </div>
                            <div class="first-1-2" v-for="item in ArticleList" :key="item.id"
                                @click="handleToDetail(item.id)">
                                <!-- <img :src="baseURL + item.cover"> -->
                                <img class="first-1-2-img" :src="baseURL + item.cover">
                                <div class="first-text">
                                    <span>{{
                                        item.title.length > 37
                                        ? item.title.substr(0, 37) + "..."
                                        : item.title
                                    }}</span>
                                    <p>{{ item.content }}</p>
                                    <div class="ft-1">
                                        <p>{{ item.createTime }}</p>
                                        <p class="ft-1-1">阅读量 :&nbsp;{{ item.viewCount }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="first-2">
                            <div class="first-2-1">
                                <div class="first-2-css"></div>
                                <span>公司动态</span>
                            </div>
                            <div v-if="companyArticleList.length > 0">
                                <div class="first-2-2" v-for="item in companyArticleList" :key="item.id"
                                    @click="handleToDetail(item.id)">
                                    <img class="first-2-2-img" :src="baseURL + item.cover">
                                    <!-- <img :src="baseURL + item.cover"> -->
                                    <span>{{ item.title }}</span>
                                    <p>阅读量 :&nbsp;{{ item.createTime }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="Pagination">
                        <el-pagination background layout="prev, pager, next" :total="total1" :page-size="8"
                            @current-change="currentChange1"></el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="公司动态" name="second">
                    <div class="first-framework-2" v-if="companyArticleList.length > 0">
                        <div class="ft-1-2" v-for="item in companyArticleList" :key="item.id"
                            @click="handleToDetail(item.id)">
                            <!-- <img :src="baseURL + item.cover"> -->
                            <img class="ft-1-2-img" :src="baseURL + item.cover">
                            <div class="ft-text">
                                <span>{{ item.title }}</span>
                                <p>{{ item.content }}</p>
                                <div class="fts-1">
                                    <p>{{ item.createTime }}</p>
                                    <p class="fts-1-1">阅读量 :&nbsp;{{ item.viewCount }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="Paginations">
                        <el-pagination background layout="prev, pager, next" :total="total2" :page-size="8"
                            @current-change="currentChange1"></el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <BUTTOM></BUTTOM>
    </div>
</template>

<script>
import {
    api_article_list,
    api_category,
    api_article_list_top,
} from "@/APi/api";
export default {
    data() {
        return {
            activeName: 'second',
            curId: 1,
            ArticleList: [],
            topArticleList: [],
            companyArticleList: [],
            leftItemFirst: {},
            id1: "",
            id2: "",
            baseURL: "",
            total1: 0,
            total2: 0,
            pageNum1: 1,
            pageNum2: 1,
            navList: [],
        };
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
        handleScroll() {
            const nav = document.querySelector('.tac'); // 导航栏元素
            const distanceFromTop = nav.offsetTop; // 导航栏距离顶部的距离

            if (window.pageYOffset > distanceFromTop) { // 当滚动距离超过导航栏距离顶部的距离时
                nav.classList.add('fixed'); // 添加固定样式类
            } else {
                nav.classList.remove('fixed'); // 移除固定样式类
            }
        },
        articleListTop() {
            api_article_list_top({
                categoryId: this.id1,
            }).then((res) => {
                this.topArticleList = res.data.rows.slice(1);
                this.leftItemFirst = res.data.rows[0];

                this.getNewsArticleList();
            });
        },
        currentChange1(index) {
            this.pageNum1 = index;
            this.getNewsArticleList();
            window.scrollTo(0, 0);
        },
        currentChange2(index) {
            this.pageNum2 = index;
            this.getCompanyArticleList();
        },
        async abc() {
            await this.getCategory();
            this.getCompanyArticleList();

            this.articleListTop();
        },
        // 跳转新闻详情
        handleToDetail(id) {
            this.$router.push({
                path: "/newsDetail",
                query: { id: id },
            });
        },
        // 获取栏目列表
        async getCategory() {
            await api_category().then((res) => {
                this.navList = res.data;
                this.id1 = this.getTreeId(res.data, "/news");
                this.id2 = this.getTreeId(res.data, "/companynews");
            });
        },
        // 获取新闻资讯文章列表
        getNewsArticleList() {
            api_article_list({
                pageNum: this.pageNum1,
                pageSize: 8,
                categoryId: this.id1,
            }).then((res) => {
                this.total1 = res.data.total;

                this.ArticleList = this.topArticleList.concat(res.data.rows);
                this.ArticleList.forEach((v) => {
                    if (v.content != null && v.content != "") {
                        var reg = /[\u4e00-\u9fa5]|[\（\）\《\》\——\；\，\。\“\”\！]/g;
                        var names = v.content.match(reg);
                        if (names != null) {
                            v.content =
                                names.join("").length > 130
                                    ? names.join("").substr(0, 130) + "..."
                                    : names.join("");
                        } else {
                            v.content = "";
                        }
                    }
                });
            });
        },
        // 获取公司动态文章列表
        getCompanyArticleList() {
            api_article_list({
                pageNum: this.pageNum2,
                pageSize: 8,
                categoryId: this.id2,
            }).then((res) => {
                this.companyArticleList = res.data.rows;
                this.total2 = res.data.total;
                this.companyArticleList.forEach((v) => {
                    if (v.content != null && v.content != "") {
                        var reg = /[\u4e00-\u9fa5]|[\（\）\《\》\——\；\，\。\“\”\！]/g;
                        var names = v.content.match(reg);
                        if (names != null) {
                            v.content =
                                names.join("").length > 130
                                    ? names.join("").substr(0, 130) + "..."
                                    : names.join("");
                        } else {
                            v.content = "";
                        }
                    }
                });
            });
        },
        // 递归查找对应categoryId
        getTreeId(tree, path) {
            let id = "";
            function getTree(tree, path) {
                tree.map((item) => {
                    if (item.route == path) {
                        id = item.id;
                        return;
                    } else {
                        if (item.children) {
                            getTree(item.children, path);
                        }
                    }
                });
            }
            getTree(tree, path);
            return id;
        },
    },
    created() {
        this.abc();
        this.getCategory();
        this.baseURL = this.GLOBAL.BASE_URL;
    },
    mounted() {
        if (!sessionStorage.getItem('isRefreshed')) {
            sessionStorage.setItem('isRefreshed', true);
            window.location.reload();
        } else {
            sessionStorage.removeItem('isRefreshed');
        }
        window.addEventListener('scroll', this.handleScroll);
    }
}
</script>

<style lang="scss" scoped>
// el-tabs
::v-deep .el-tabs--card>.el-tabs__header {
    border-bottom: 0;
}

::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
    border: 0;
}

::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item {
    border-left: 0px;
    width: 7.8125rem;
    height: 3rem;
    text-align: center;
}

::v-deep .el-tabs__item.is-active {
    color: white;
    background-color: #014F93;
}

.Pagination {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 2.375rem;
    margin-bottom: 1.75rem;
}

.Paginations {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 4.6875rem;
    margin-bottom: 11.25rem;
}

// 导航菜单
::v-deep .el-row {
    width: 13rem;
}

::v-deep .el-submenu {
    width: 13rem;
}

::v-deep .el-col-12 {
    width: 100%;
}

::v-deep .el-menu {
    background-color: transparent;
    display: flex;
    flex-direction: column;
}

::v-deep .el-submenu .el-menu-item {
    color: white;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

::v-deep .el-submenu__title {
    color: white;
    background-color: transparent !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
}

::v-deep .el-icon-arrow-down:before {
    color: white;
}

::v-deep .el-submenu .el-menu-item {
    background-color: transparent !important;
}

::v-deep .el-menu {
    background-color: transparent !important;
}

.tac {
    z-index: 2;
    position: absolute;
    right: 0;
    top: 0;
    background: linear-gradient(90deg, rgba(56, 98, 154, 0) 0%, rgba(58, 100, 156, 0.86) 100%);
}

::v-deep .el-menu-item-group>ul {
    height: 44rem;
}
p:hover {
    transition: all .6s linear;
    color: rgb(1, 79, 147);
    cursor: pointer;
}

span:hover {
    transition: all .6s linear;
    color: rgb(1, 79, 147);
    cursor: pointer;
}
.tac.fixed {
    position: fixed;
    right: 0;
}

.linkclass {
    text-decoration: none;
    color: white;
}

// 
.top {
    width: 100%;
    height: 15.13rem;
    background-image: url(../image/news.png);
    background-size: 100% 100%;
    margin-bottom: 4.2rem;

    .loGo {
        width: 8.13rem;
        height: 2.51rem;
        margin-left: 5.81rem;
    }

    .logo-1 {
        width: 1.63rem;
        height: 1.63rem;
        margin-right: 5.81rem;
    }

    .introduce {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 7rem;

        .p1 {
            font-size: 2.25rem;
            color: white;
        }

        .p2 {
            font-size: 1.13rem;
            color: white;
        }
    }
}

// 

.tabs {
    width: 57.5rem;
    margin: 0 auto;

    .first-framework {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: flex-start;

        img {
            transition: transform 0.8s ease-in-out;
        }

        img:hover {
            transform: scale(1.05);
        }

        // display: flex;
        .first-1 {
            width: 34.5625rem;
            height: auto;

            .first-1-1 {
                width: 100%;
                height: 15.75rem;

                .first-1-1-img {
                    width: 100%;
                    height: 100%;
                    cursor: pointer;
                }

                p {
                    font-size: 1rem;
                    color: white;
                    position: absolute;
                    top: 13.1875rem;
                    left: .8125rem;
                }
            }

            .first-1-2 {
                width: 100%;
                height: 8.5rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-start;
                padding: 2rem 0px;

                .first-text {
                    width: 18.8125rem;
                    height: 8.5rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    align-items: flex-start;

                    span {
                        font-size: .875rem;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #333333;
                    }

                    p {
                        font-size: .8125rem;
                        color: #999999;
                    }

                    .ft-1 {
                        display: flex;
                        flex-direction: row;

                        .ft-1-1 {
                            margin-left: 2.5rem;
                        }
                    }
                }

                .first-1-2-img {
                    width: 14.5625rem;
                    height: 8.5rem;
                    cursor: pointer;
                }
            }
        }

        .first-2 {
            width: 21.5rem;
            height: auto;
            display: flex;
            flex-direction: column;

            .first-2-1 {
                display: flex;
                align-items: center;
                flex-direction: row;

                .first-2-css {
                    width: .1875rem;
                    height: 1.1875rem;
                    background: #014F93;
                    border-radius: .0625rem;
                }

                span {
                    font-size: 1rem;
                    color: #333333;
                    margin-left: .4375rem;
                }
            }

            .first-2-2 {
                width: 21.5rem;
                height: 13.4375rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
                padding: 1.2188rem 0rem;

                .first-2-2-img {
                    width: 21.5rem;
                    height: 10.3125rem;
                    cursor: pointer;
                }

                span {
                    font-size: .875rem;
                    color: #333333;
                }

                p {
                    font-size: .6875rem;
                    color: #999999;
                }
            }
        }
    }

    .first-framework-2 {
        width: 52.0625rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        img {
            transition: transform 0.8s ease-in-out;
        }

        img:hover {
            transform: scale(1.05);
        }

        .ft-1-2 {
            width: 100%;
            height: 10.5625rem;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            padding: 1.5rem 0px;

            .ft-text {
                width: 30.75rem;
                height: 10.5625rem;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                align-items: flex-start;

                span {
                    font-size: 1.0625rem;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                }

                p {
                    font-size: .8125rem;
                    color: #999999;
                }

                .fts-1 {
                    display: flex;
                    flex-direction: row;

                    .fts-1-1 {
                        margin-left: 3.4375rem;
                    }
                }
            }

            .ft-1-2-img {
                width: 19.5rem;
                height: 10.5625rem;
                cursor: pointer;
            }
        }
    }
}

// 移动端
@media screen and (max-width: 900px) {

    // 移动
    // el-tabs
    ::v-deep .el-tabs--card>.el-tabs__header {
        border-bottom: 0;
    }

    ::v-deep .el-tabs--card>.el-tabs__header {
        border-bottom: 0;
    }

    ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
        border: 0;
    }

    ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item {
        border-left: 0px;
        width: 7.8125rem;
        height: 3rem;
        text-align: center;
    }

    ::v-deep .el-tabs__item.is-active {
        color: white;
        background-color: #014F93;
    }

    ::v-deep .el-tabs__nav-scroll {
        margin-left: 18%;
    }

    .Pagination {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 2.375rem;
        margin-bottom: 1.75rem;
    }

    .Paginations {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 4.6875rem;
        margin-bottom: 11.25rem;
    }

    // 导航菜单
    ::v-deep .el-row {
        width: 8.5rem;
    }

    ::v-deep .el-submenu {
        width: 8.5rem;
    }

    ::v-deep .el-col-12 {
        width: 100%;
    }

    ::v-deep .el-menu {
        background-color: transparent;
        display: flex;
        flex-direction: column;
    }

    ::v-deep .el-submenu .el-menu-item {
        color: white;
        background-color: transparent;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    ::v-deep .el-submenu__title {
        width: 8.5rem;
        color: white;
        background-color: transparent !important;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }

    ::v-deep .el-icon-arrow-down:before {
        color: white;
    }

    ::v-deep .el-submenu .el-menu-item {
        background-color: transparent !important;
    }

    ::v-deep .el-menu {
        background-color: transparent !important;
    }

    .tac {
        width: 35%;
        z-index: 2;
        position: absolute;
        right: 0;
        top: 0;
        background: linear-gradient(90deg, rgba(56, 98, 154, 0) 0%, rgba(58, 100, 156, 0.86) 100%);
    }

    ::v-deep .el-menu-item-group>ul {
        height: 49rem;
    }

    .tac.fixed {
        position: fixed;
        right: 0;
    }

    .linkclass {
        text-decoration: none;
        color: white;
    }

    // 
    .top {
        width: 100%;
        height: 15.13rem;
        background-image: url(../image/news.png);
        background-size: 100% 100%;
        margin-bottom: 4.2rem;

        .loGo {
            width: 8.13rem;
            height: 2.51rem;
            margin-left: 0rem;
            margin-top: 0.5rem;
        }

        .logo-1 {
            width: 1.63rem;
            height: 1.63rem;
            margin-right: 5.81rem;
        }

        .introduce {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 7rem;

            .p1 {
                display: none;
                font-size: 2.25rem;
                color: white;
            }

            .p1none {
                display: block !important;
                font-size: 2.25rem;
                color: white;
            }

            .p2 {
                display: none;
                font-size: 1.13rem;
                color: white;
            }

            .p2none {
                display: block !important;
                font-size: 1.13rem;
                color: white;
            }
        }
    }

    // 

    .tabs {
        width: 100%;
        margin: 0 auto;

        .first-framework {
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            align-items: flex-start;

            img {
                transition: transform 0.8s ease-in-out;
            }

            img:hover {
                transform: scale(1.05);
            }

            // display: flex;
            .first-1 {
                width: 100%;
                height: auto;

                .first-1-1 {
                    width: 96%;
                    height: 15.75rem;
                    margin-left: 2%;

                    .first-1-1-img {
                        width: 100%;
                        height: 100%;
                    }

                    p {
                        font-size: 1rem;
                        color: white;
                        position: absolute;
                        top: 13.1875rem;
                        left: .8125rem;
                    }
                }

                .first-1-2 {
                    width: 96%;
                    height: 16.5rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-start;
                    padding: 2rem 0px;
                    margin: auto;

                    .first-text {
                        width: 96%;
                        height: 8.5rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-evenly;
                        align-items: center;
                        margin: auto;

                        span {
                            font-size: .875rem;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: #333333;
                        }

                        p {
                            font-size: .8125rem;
                            color: #999999;
                        }

                        .ft-1 {
                            display: flex;
                            flex-direction: row;

                            .ft-1-1 {
                                margin-left: 2.5rem;
                            }
                        }
                    }

                    .first-1-2-img {
                        width: 96%;
                        height: 8.5rem;
                        margin: auto;
                        cursor: pointer;
                    }
                }
            }

            .first-2 {
                display: none !important;
                width: 21.5rem;
                height: auto;
                display: flex;
                flex-direction: column;

                .first-2-1 {
                    display: flex;
                    align-items: center;
                    flex-direction: row;

                    .first-2-css {
                        width: .1875rem;
                        height: 1.1875rem;
                        background: #014F93;
                        border-radius: .0625rem;
                    }

                    span {
                        font-size: 1rem;
                        color: #333333;
                        margin-left: .4375rem;
                    }
                }

                .first-2-2 {
                    width: 21.5rem;
                    height: 13.4375rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-start;
                    padding: 1.2188rem 0rem;

                    .first-2-2-img {
                        width: 21.5rem;
                        height: 10.3125rem;
                    }

                    span {
                        font-size: .875rem;
                        color: #333333;
                    }

                    p {
                        font-size: .6875rem;
                        color: #999999;
                    }
                }
            }
        }

        .first-framework-2 {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            img {
                transition: transform 0.8s ease-in-out;
            }

            img:hover {
                transform: scale(1.05);
            }

            .ft-1-2 {
                width: 96%;
                height: 21.5625rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding: 1.5rem 0px;
                margin: auto;

                .ft-text {
                    width: 96%;
                    height: 10.5625rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    align-items: center;

                    span {
                        font-size: 1.0625rem;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #333333;
                    }

                    p {
                        width: 96%;
                        font-size: .8125rem;
                        color: #999999;
                        text-align: center;
                    }

                    .fts-1 {
                        display: flex;
                        flex-direction: row;
                        width: 96%;
                        align-items: center;
                        margin-left: 17%;

                        .fts-1-1 {
                            margin-left: 3.4375rem;
                        }
                    }
                }

                .ft-1-2-img {
                    width: 96%;
                    height: 10.5625rem;
                }
            }
        }
    }
}
</style>